export function buildEventPublicShareUrl(input: {
  portalBase: string | undefined | null;
  shareToken: string;
  studioId?: string;
}): string {
  const rawBase =
    typeof input.portalBase === 'string' ? input.portalBase.trim() : '';
  const base = rawBase.length > 0 ? rawBase.replace(/\/$/, '') : '';
  const shareToken =
    typeof input.shareToken === 'string' ? input.shareToken.trim() : '';

  if (!base || shareToken.length === 0) {
    return '';
  }

  try {
    const u = new URL(
      `${base}/public-event-share/${encodeURIComponent(shareToken)}`,
    );
    const studioId =
      typeof input.studioId === 'string' ? input.studioId.trim() : '';
    if (studioId.length > 0) {
      u.searchParams.set('studioId', studioId);
    }
    return u.toString();
  } catch {
    return '';
  }
}

export function buildEventPublicShareEmbedUrl(shareUrl: string): string {
  const trimmed = typeof shareUrl === 'string' ? shareUrl.trim() : '';
  if (trimmed.length === 0) {
    return '';
  }

  try {
    const url = new URL(trimmed);
    url.searchParams.delete('embedded');
    return url.toString();
  } catch {
    return '';
  }
}

export function buildEventPublicShareIframeEmbedHtml(embedUrl: string): string {
  const trimmed = typeof embedUrl === 'string' ? embedUrl.trim() : '';
  if (trimmed.length === 0) {
    return '';
  }

  return `<iframe
  title="Event details"
  src="${trimmed}"
  width="100%"
  height="850"
  style="width:100%;min-height:850px;border:0"
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
></iframe>`;
}
